<template>
  <div>
    <baseInfo ref="baseInfo" :info="info" />
    <history ref="history" :approve-log-list="approveLogList" />
    <return-exc-opt ref="history" :data-list="excList" />
    <p style="font-size:16px;font-weight:800;margin: 10px 10px;">
      附件信息
    </p>
    <contract-file :contract-id="num" :is-init="true" :is-show="isShow" />
    <product ref="productList" :product-data="productData" :info="info" />
    <el-button type="primary" :loading="isSubmitLoading" @click="submit">
      发布
    </el-button>
    <el-button v-if="isDisabledReject" type="primary" @click="reject">
      驳回到代理商
    </el-button>
    <!-- <el-button type="primary" :loading="isSaveLoading" @click="save">保存草稿</el-button> -->
    <el-dialog title="驳回意见" :visible.sync="rejectedVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="500" lock-scroll>
      <div>
        <el-input
          v-model="rejectedInfo"
          type="textarea"
          placeholder="请输入您的驳回意见"
          maxlength="200"
          show-word-limit
          rows="6"
        />
      </div>
      <div class="block" style="text-align: right;padding-top: 20px">
        <el-button @click="rejectedVisible=false">
          取 消
        </el-button>
        <el-button type="primary" @click="submitReject">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="es6">
import baseInfo from './baseInfo';
import history from './history.vue';
import returnExcOpt from './returnExcOpt.vue';
import product from './product.vue';
import contractFile from '../../returnExchange/Chief/commom/file.vue';
import { orderDetail, checkSubmit, rSubmit, orderCancel, getOrderApprovalOpinion } from '@/API';
export default {
  components: {
    baseInfo,
    history,
    returnExcOpt,
    contractFile,
    product
  },

  data () {
    return {
      info: {},
      loading: false,
      productLoading: false,
      ishard: true,
      rejectedLoading: false,
      contractId: '',
      email: '',
      num: this.$route.query.contractId,
      rejectedVisible: false,
      approveLogList: [],
      productData: [],
      isShow: false,
      rejectedInfo: '',
      // 退换货审批意见
      excList: [],
      isSubmitLoading: false,
      isSaveLoading: false
    };
  },

  computed: {
    isDisabledReject () {
      // 注：r_reason_type 落库值为“产品发运错误”，与“发运错误原因”不相等，
      // 本判断实际不命中。属既有缺陷（非本次改名范围），修复需业务确认后单独处理。
      if (!this.info.rreasonType || this.info.rreasonType === '发运错误原因') return false;
      return true;
    }
  },

  methods: {
    initData () {
      let parmas = { contractId: this.$route.query.contractId, contractType: this.$route.query.contractType };
      orderDetail(parmas).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.info = json.data.baseInfoModelVO;
          this.approveLogList = json.data.approveLogList;
          this.productData = json.data.addressMOdelVOS;
          this.queryExcData(json.data.baseInfoModelVO.contractId);
        }
      }).catch((res) => {
      });
    },

    // 获取 退换货审批意见
    queryExcData () {
      let parmas = { contractId: this.$route.query.contractId, contractType: this.$route.query.contractType };
      getOrderApprovalOpinion(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.excList = json.data;
        }
      }).catch((res) => {});
    },

    // 发布
    submit () {
      let parmas = {
        baseInfo: this.$refs.baseInfo.info,
        postAddressInfoList: [
          {
            proList: this.$refs.productList.rejectedList[0].addressList[0].contractProductList,
            rpostAddressId: this.$refs.productList.rejectedList[0].addressList[0].rid
          }
        ]
      };

      if (this.$route.query.contractType === '退货合同') {
        let list = parmas.postAddressInfoList[0].proList;
        for (let i = 0; i < list.length; i++) {
          let row = list[i];
          if (row.rdeliverSign === 1 && !row.rstorageName) {
            return this.$message.error('请输入库位');
          }
        }
      }

      let _this = this;
      function submitData (data) {
        rSubmit(data).then((res) => {
          let { status } = res.data;
          if (status === '200') {
            _this.$message.success('提交成功');
            _this.isSubmitLoading = false;
            _this.$router.replace({ name: 'orderPersionContractList' });
          }
        }).catch(() => { _this.isSubmitLoading = false; });
      }

      this.isSubmitLoading = true;
      checkSubmit({ contractId: this.$route.query.contractId }).then(res => {
        let { status, data, err } = res.data;
        if (status === '200') {
          if (data) {
            submitData(parmas);
          } else {
            let obj = { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' };
            this.$confirm(err, '提示', obj).then(() => {
              submitData(parmas);
            }).catch(() => { this.isSubmitLoading = false; });
          }
        }
      });
    },

    // 保存草稿
    save () {
      let parmas = {
        baseInfo: { ...this.$refs.baseInfo.info, risDraft: true },
        postAddressInfoList: [
          {
            proList: this.$refs.productList.rejectedList[0].addressList[0].contractProductList,
            rpostAddressId: this.$refs.productList.rejectedList[0].addressList[0].rid
          }
        ]
      };

      this.isSaveLoading = true;
      rSubmit(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('提交成功');
          this.isSaveLoading = false;
          this.$router.replace({ name: 'orderPersionContractList' });
        }
      }).catch(() => { this.isSaveLoading = false; });
    },

    // 驳回到代理商
    reject () {
      this.rejectedVisible = true;
    },

    submitReject () {
      let parmas = {
        contractId: this.$route.query.contractId,
        contractNum: this.$refs.baseInfo.info.rnewContractNum,
        action: 'reject',
        remarks: this.rejectedInfo
      };
      orderCancel(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('驳回成功');
          this.$router.replace({ name: 'orderPersionContractList' });
        }
      }).catch((error) => {
        this.$message.success('驳回失败！', error);
      });
    }
  },
  mounted () {
    this.initData();
  },
  watch: {

  }
};
</script>
<style>
  .rj-page-card:nth-of-type(3){
    margin-bottom: 0;
    padding-bottom: 0;
    overflow: hidden;
  }
</style>
